import _filenamify from 'filenamify/browser';
import { dateFormatter } from '@/helpers/formatters';

const appName = 'jij-bent-pro';

export async function downloadBlobAs (
  blobOrFile: Blob | File,
  filename: string,
  dirHandle?: FileSystemDirectoryHandle,
) {
  if (dirHandle) {
    const fileHandle = await dirHandle.getFileHandle(filename, { create: true });
    const writable = await fileHandle.createWritable();
    await writable.write(blobOrFile);
    await writable.close();
    return;
  }

  const tempUrl = URL.createObjectURL(blobOrFile);
  const link = document.createElement('a');

  link.href = tempUrl;
  link.download = filename;

  document.body.appendChild(link);
  link.dispatchEvent(new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window,
  }));
  document.body.removeChild(link);

  URL.revokeObjectURL(tempUrl);
}

function getExportDateStr (date: Date) {
  const dateParts = dateFormatter.formatToParts(date);
  const YYYY = dateParts.find((part) => part.type === 'year')!.value;
  const MM = dateParts.find((part) => part.type === 'month')!.value;
  const DD = dateParts.find((part) => part.type === 'day')!.value;
  const hh = dateParts.find((part) => part.type === 'hour')!.value;
  const mm = dateParts.find((part) => part.type === 'minute')!.value;
  const ss = dateParts.find((part) => part.type === 'second')!.value;

  return `${YYYY}-${MM}-${DD}T${hh}:${mm}:${ss}`;
}

export function filenamify (name: string) {
  return _filenamify(name);
}

export function getExportFilename ({
  extension,
  topic = '',
  date = new Date(),
  short = false,
}: {
  extension?: string;
  topic?: string;
  date?: Date;
  short?: boolean;
}) {
  const topicSafe = topic ? filenamify(topic) : null;

  let filename = '';

  if (short) {
    if (!topicSafe) {
      throw new Error('Provide a topic when using the short notation');
    }

    filename += topicSafe;
  }
  else {
    filename += appName;

    if (topicSafe) {
      filename += `_${topicSafe}`;
    }

    filename += `_${getExportDateStr(date)}`;
  }

  if (extension) {
    filename += `.${extension}`;
  }

  return filename.replace(/ /g, '_');
}
